<template>
    <div class="footer">
        <!--<div class="container">
          <div class="content">
            <div v-for="item in formData" :key="item.id" class="navItem">
              <div class="title">{{ item.name }}</div>
              <div v-for="sub_item in item.child" :key="sub_item.id">
                <span @click="gotoExplain(sub_item, 2)" style="cursor: pointer">{{ sub_item.name }}</span>
              </div>

            </div>
            <div class="right">
              <label class="codeTitle">
                <p>扫码关注</p>
                <p>阅读健康咨询</p>
              </label>
              <img class="img" src="../../assets/images/views/qrcode.jpg" />
            </div>
          </div>
        </div>-->
        <div class="container">
            <div class="clearfix" style="margin: 0 auto;">
                <div class="fl" v-for="(item, i) in formData" :key="item.id">
                    <span @click="gotoExplain(item, 2)" style="cursor: pointer;"> {{ item.name }}</span>
                    <em v-if="i < formData.length - 1"> |</em>
                </div>
            </div>
        </div>
        <div class="tc" style="width:100%;">
            <div class="layer">
                <div class="left">
                    <p>Copyright©  2020-2024 浙江温周 版权所有 保留一切权利</p>
                    <p><a href="https://beian.miit.gov.cn/" target="_blank">浙ICP备2021038242号-1</a> | <a :href="require('../../assets/images/verification/DrugLicense.jpg')" target="_blank">药品经营许可证 </a><!--|<a href="http://www.goodyiyao.com/images/certificate/FoodBusiness.jpg" target="_blank"> 食品经营许可证 </a>|<a href="http://www.goodyiyao.com/images/certificate/InternetMedicine.jpg" target="_blank"> 互联网药品信息服务资格证书 </a>-->|<a :href="require('../../assets/images/verification/TradingCertificate.jpg')" target="_blank">企业法人营业执照 </a>|<a :href="require('../../assets/images/verification/InternetCertificate.jpg')" target="_blank">互联网药品信息服务资格证书 </a></p><p><a :href="require('../../assets/images/verification/SecondClass.jpg')" target="_blank"> 第二类医疗器械备案 </a><!--|<a href="http://www.goodyiyao.com/images/certificate/GSP.jpg" target="_blank"> GSP认证证书 </a>|<a href="http://www.goodyiyao.com/images/certificate/MedicalDevice.jpg" target="_blank"> 医疗器械经营许可证</a>--><a target="_blank" class="split" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33032202000199">浙公网安备 33032202000199号</a></p>
                </div>
                <!--<div class="container">-->
                <!--<div class="clearfix" style="margin: 0 auto;">-->
                <!--<div class="fl" v-for="(item, i) in formData" :key="item.id">-->
                <!--<span @click="gotoExplain(item, 2)" style="cursor: pointer;">{{ item.name }}</span>-->
                <!--<em v-if="i < formData.length - 1"> | </em>-->
                <!--</div>-->
                <!--</div>-->
                <!--</div>-->
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'appfooter',
        data() {
            return{
            }
        },
        computed: {
            formData() {
                let aboutNav = [];
                for(let i in this.$store.getters.shop_index.footerNav){
                    if(this.$store.getters.shop_index.footerNav[i].id === 81){
                        aboutNav = this.$store.getters.shop_index.footerNav[i].child;
                    }
                }
//                console.log(aboutNav);
                return aboutNav;
            }
        },
        mounted() {

        },
        methods: {
            gotoExplain(data, level) {
                if(data.data_type === 'custom') {
                    window.open(data.url)
                }else if(data.data_type ==='customview'){
                    this.$router.push(`/custom/${data.value}`)
                }else if (data.data_type === 'article_class') {
                    this.$router.push(`/explain/detail/${data.value}`)
                } else if(data.data_type === 'goods_category') {
                    this.$router.push(`/drugCategory?${level === 1 ? 'category_id' : 'cat_id'}=${data.value}`)
                }
            }
        },
    }
</script>

<style lang="scss" scoped>
    .footer {
        width: 100%;
        display: flex;
        flex-direction: column;
    }

    .container {
        margin: 0 auto;
        width: 1200px;
        padding-bottom: 10px;
        padding-top: 56px;
        display: flex;
        flex-wrap: wrap;
    }

    .content {
        flex: 1;
        display: flex;
        flex-direction: row;
        justify-content: space-around;
        .title{
            font-weight: 700;
            color: #333;
            font-size: 15px;
            cursor: default;
        }
        .right{
            display: flex;
            .codeTitle {
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                height: 100px;
                margin-right: 15px;
            }
        }
        .navItem{
            display: flex;
            cursor: default;
            flex-direction: column;
            width: 20%;
            color: #666;
            >div{
                margin-top: 5px;
            }
        }
    }

    .qrcode {
        display: flex;
        width: 230px;
        align-items: center;
        justify-content: space-between;
        margin-right: 120px;
    }



    .codeTitle p {
        white-space: nowrap;
    }

    .row {
        display: flex;
    }

    .col {
        margin-right: 30px;
    }

    .img {
        width: 100px;
        height: 100px;
    }

    .icon {
        height: 28px;
        width: 28px;
        font-size: 28px;
        margin-right: 10px;
        margin-left: -40px;
    }

    .navTitle {
        display: flex;
        font-size: 14px;
        font-weight: 600;
        align-items: center;
        white-space: nowrap;
    }

    .navItem {
        display: flex;
        justify-content: left;
        color: #999;
        margin-top: 4px;
        font-size: 13px;
        cursor: pointer;
        text-align: center;
    }
    .tc{
        font-size: 12px;
        background: #f6f5f5;
        color: #999;
        padding: 15px 0 5px;
        margin-top: 15px;
        .layer{
            display: flex;
        }
        .left{
            width: 1200px;
            margin: 0 auto;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
        }
        .right{
            width: 800px;
            display: flex;
            justify-content: flex-end;
            flex-direction: row;
            .codeTitle{
                margin-top: 35px;
                margin-right: 15px;
            }
        }
        a{
            color: #999;
        }
        .split{
            width: 800px;
            margin: 0 auto;
            background: url('../../assets/images/icon/recode.png') 300px center no-repeat;
            text-indent: 2em;
            height: 30px;
            line-height: 30px;
            display: block;
        }
    }

</style>